.media {
  padding: 72px 0;
}

.media__grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 18px;
  margin-bottom: 48px;
}

.media__cell {
  aspect-ratio: 16 / 9;
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Grid items default to min-width: auto, so WebKit sizes the track to each logo's intrinsic
     (SVG) width — on narrow screens that blows the grid past the viewport, which in turn makes the
     aspect-ratio cells overshoot and shove the CTA into the grid. min-width: 0 lets tracks shrink. */
  min-width: 0;
  padding: 22px;
  text-align: center;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.media__cell:hover {
  box-shadow: var(--plume-shadow-media-hover, 1px 2px 10px 0 rgba(89, 84, 78, 0.12));
  transform: var(--plume-hover-shift, translateY(-3px));
}

/* Outlet logo. Capped on BOTH axes so wildly different aspect ratios (a square mark like
   France Inter vs. an ultra-wide wordmark like The Guardian) read as the same optical weight:
   max-height governs tall/square marks, max-width reins in the widest, object-fit keeps them
   undistorted. Brand colours are kept — they sit well inside the white cards. */
.media__logo {
  display: block;
  width: auto;
  height: auto;
  /* Shared size cap, optionally nudged per logo via --logo-scale (see content.ts). min(100%, …)
     keeps a scaled-up mark from ever spilling past its card. */
  max-width: min(100%, calc(132px * var(--logo-scale, 1)));
  max-height: calc(38px * var(--logo-scale, 1));
  object-fit: contain;
}

/* Laptop/desktop (hover-capable pointers): logos sit in black & white and reveal their brand
   colour on hover. Touch devices (hover: none) keep the colours, since there's no hover there. */
@media (hover: hover) {
  .media__logo {
    filter: grayscale(1);
    transition: filter 0.2s ease;
  }

  .media__cell:hover .media__logo {
    filter: none;
  }
}

.media__cta {
  display: flex;
  justify-content: center;
}

@media (max-width: 860px) {
  .media__grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 560px) {
  .media__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
